<template>
  <el-main>
    <el-form class="el-form-search" :model="ruleForm" label-width="120px">
      <el-form-item label="订单编号：">
        <el-input size="small" placeholder="请输入订单编号" v-model="ruleForm.order_no"></el-input>
      </el-form-item>
      <el-form-item label="收货人姓名：">
        <el-input size="small" placeholder="请输入收货人姓名" v-model="ruleForm.consignee_name"></el-input>
      </el-form-item>
      <el-form-item label="收货人手机号：">
        <el-input size="small" placeholder="请输入收货人手机号" v-model="ruleForm.consignee_phone"></el-input>
      </el-form-item>
      <el-form-item label="下单时间：">
        <el-date-picker v-model="ruleForm.timeVal" size="small" type="daterange" range-separator="~" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
      </el-form-item>
      <el-form-item label="商品名称：">
        <el-input size="small" placeholder="请输入商品名称/编号" v-model="ruleForm.goods_name"></el-input>
      </el-form-item>
      <el-form-item label=" " label-width="45px">
        <el-button type="primary" size="small" @click="serarch">搜索</el-button>
        <!-- <el-button size="small" @click="exportOrder">导出</el-button> -->
        <el-button plain size="small" @click="cancelSearch">清空搜索条件</el-button>
      </el-form-item>
    </el-form>
    <el-tabs type="card" v-model="tab_type" @tab-click="tabClick">
      <el-tab-pane :name="item.status" v-for="(item, index) in order_num" :key="index">
        <span slot="label">{{ item.title }}({{ item.count }}）</span>
      </el-tab-pane>
    </el-tabs>
    <orderTable ref="orderTable" :ruleForm="ruleForm" :status="tab_type"></orderTable>
    <el-dialog title="打印订单设置" :visible.sync="showSetPrinting" width="35%">
      <el-form>
        <el-form-item label="是否打印："></el-form-item>
        <el-form-item>
          <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
        </el-form-item>
        <el-form-item>
          <el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange">
            <el-checkbox v-for="city in cities" :label="city" :key="city">{{ city }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showSetPrinting = !1">取 消</el-button>
        <el-button type="primary" @click="setPrintCon">确 定</el-button>
      </span>
    </el-dialog>
  </el-main>
</template>

<script>
import orderTable from './components/orderTable';
import config from '@/util/config';
let print_con = localStorage.getItem('printCon') || ['商品图片', '商品单价', '商品总价', '优惠金额', '快递运费', '商家备注'];
if (typeof print_con == 'string') {
  print_con = JSON.parse(print_con);
}
export default {
  data() {
    return {
      showSetPrinting: !1,
      checkAll: !1,
      checkedCities: print_con,
      cities: ['商品图片', '商品单价', '商品总价', '优惠金额', '快递运费', '商家备注'],
      isIndeterminate: !0,
      order_num: {},
      form: {
        page: 1,
        rows: 10,
        state_type: 'all',
        payment_code: 'whole', //支付方式
        feedback_state: 'whole', //售后状态
        from: 'whole', //订单来源
        keywords_type: '', //搜索类型
        keywords: '', //搜索内容
        create_time: [],
        group_sign: '',
      },
      ruleForm: {
        order_no: '',
        goods_name: '',
        consignee_name: '',
        consignee_phone: '',
        timeVal: [],
      },
      tab_type: 0,
      feedback_state: [
        {
          val: 'whole',
          label: '全部',
        },
        {
          val: 'todo',
          label: '申请售后',
        },
        {
          val: 'closed',
          label: '售后完成',
        },
      ],
      pay_type: [
        {
          val: 'whole',
          label: '全部',
        },
        {
          val: 10,
          label: '微信支付',
        },
        {
          val: 20,
          label: '支付宝支付',
        },
        {
          val: 30,
          label: '华为支付',
        },
        {
          val: 40,
          label: '余额支付',
        },
        {
          val: 50,
          label: '会员卡支付',
        },
      ],
      order_source: [
        {
          val: 'whole',
          label: '全部',
        },
        {
          val: '1',
          label: '微信',
        },
        {
          val: '2',
          label: '支付宝',
        },
        {
          val: '3',
          label: '快应用',
        },
        {
          val: '4',
          label: '抖音',
        },
        {
          val: '5',
          label: 'QQ',
        },
        {
          val: '6',
          label: '百度',
        },
      ],
      value: '',
    };
  },
  components: {
    orderTable: orderTable,
  },
  created() {
    this.getOrderNum();
  },
  methods: {
    //导出订单
    exportOrder() {
      let content = this.form;
      let data = {
        page: content.page,
        rows: content.rows,
        create_time: content.create_time,
        group_sign: content.group_sign,
      };
      if (content.state_type == 'group_state_pay') {
        data.group_state_type = 'group_state_pay';
        data.state_type = 'all';
      } else {
        data.state_type = content.state_type;
      }
      if (content.payment_code != 'whole') {
        data.payment_code = content.payment_code;
      }
      if (content.feedback_state != 'whole') {
        data.feedback_state = content.feedback_state;
      }
      if (content.from != 'whole') {
        data.from = content.from;
      }
      if (content.keywords) {
        data.keywords_type = content.keywords_type;
        data.keywords = content.keywords;
      }
      if (content.room_id) {
        data.room_id = content.room_id;
        data.goods_id = content.goods_id;
      }
      data.is_export = 1;
      this.$axios.post(this.$api.order.list, data).then(res => {
        if (res.code == 0) {
          let path = config.baseurl + '/' + res.result;
          let a = document.createElement('a');
          a.href = path;
          a.id = 'download';
          document.body.appendChild(a);
          a.click();
          let aDom = document.getElementById('download');
          document.body.removeChild(aDom);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleCheckAllChange(val) {
      this.checkedCities = val ? print_con : [];
      this.isIndeterminate = !1;
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.cities.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.cities.length;
    },
    //设置打印内容
    setPrintCon() {
      this.showSetPrinting = !1;
      localStorage.setItem('printCon', JSON.stringify(this.checkedCities));
    },
    tabClick() {
      console.log(this.tab_type);
      this.$refs.orderTable.page = 1;
      this.$refs.orderTable.rows = 10;
      this.$refs.orderTable.getList();
    },
    getOrderNum() {
      let data = {};
      if (this.ruleForm.order_no) data.order_no = this.ruleForm.order_no;
      if (this.ruleForm.goods_name) data.goods_name = this.ruleForm.goods_name;
      if (this.ruleForm.consignee_name) data.consignee_name = this.ruleForm.consignee_name;
      if (this.ruleForm.consignee_phone) data.consignee_phone = this.ruleForm.consignee_phone;
      if (this.ruleForm.timeVal?.length) {
        data.start_time = this.ruleForm.timeVal[0].getTime() / 1000;
        data.end_time = this.ruleForm.timeVal[1].getTime() / 1000;
        if (data.start_time == data.end_time) data.end_time = data.end_time + 86400;
      }
      this.$axios.post(this.$api.integral.order.orderStatus, data).then(res => {
        if (res.code == 0) {
          this.order_num = res.result;
        }
      });
    },
    serarch() {
      this.getOrderNum();
      this.$refs.orderTable.getList();
    },
    cancelSearch() {
      this.ruleForm = {
        order_no: '',
        goods_name: '',
        consignee_name: '',
        consignee_phone: '',
        timeVal: [],
      };
      this.getOrderNum();
      // this.$refs.orderTable.getList();
    },
  },
};
</script>

<style lang="less" scoped>
.el-main {
  background: #fff;
}
</style>
